import React from 'react';
import { Card, ProgressBar, Badge, Row, Col } from 'react-bootstrap';

const OptionAttachRateCard = ({ data, isLoading }) => {
    if (isLoading) {
        return <div>옵션 채택률 로딩 중...</div>;
    }

    if (!data || !data.options || data.options.length === 0) {
        return (
            <Card>
                <Card.Body>
                    <Card.Title>옵션 채택률</Card.Title>
                    <Card.Text>표시할 데이터가 없습니다.</Card.Text>
                </Card.Body>
            </Card>
        );
    }

    const { totalRecords, options } = data;

    const DeltaBadge = ({ delta }) => {
        if (delta === 0 || !delta) {
            return <Badge bg="secondary" className="ms-2">변동 없음</Badge>;
        }
        if (delta > 0) {
            return <Badge bg="success" className="ms-2">▲ {delta.toFixed(1)}%p</Badge>;
        }
        return <Badge bg="danger" className="ms-2">▼ {Math.abs(delta).toFixed(1)}%p</Badge>;
    };

    return (
        <Card>
            <Card.Header>
                <Card.Title as="h5" className="mb-0">
                    옵션 채택률 (총 {totalRecords}건 기준)
                </Card.Title>
            </Card.Header>
            <Card.Body>
                {options.map((option, index) => (
                    <div key={index} className={index === options.length - 1 ? '' : 'mb-4'}>
                        <Row className="align-items-center">
                            <Col>
                                <div className="d-flex justify-content-between">
                                    <strong>{option.optionName}</strong>
                                    <span>
                                        {option.count}건 ({option.rate}%)
                                        <DeltaBadge delta={option.delta} />
                                    </span>
                                </div>
                            </Col>
                        </Row>
                        <ProgressBar 
                            now={option.rate} 
                            label={`${option.rate}%`} 
                            className="mt-2" 
                            style={{ height: '20px' }} 
                        />
                    </div>
                ))}
            </Card.Body>
        </Card>
    );
};

export default OptionAttachRateCard;
